// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"5e527f7e","312":"063bfac3","453":"c905a40f","828":"ebe90c0f"}[chunkId] + ".chunk.js";
};